var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOvalFilled = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "8px",
  height: "8px",
  viewBox: "0 0 8 8",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Oval-filled") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "bullet-_nav---/-1",
  transform: "translate(-2.000000, -2.000000)",
  fill: "#02339c"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-filled",
  cx: 6,
  cy: 6,
  r: 4
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOvalFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Oval-filled.affe96957a428e0556d04450a8b8eb18.svg";